export const preventClickEventBehaviours = (event: React.MouseEvent) => {
  event.preventDefault();
  event.stopPropagation();
  const nativeEvent = event.nativeEvent as unknown as {
    stopImmediatePropagation?: () => void;
  };
  nativeEvent?.stopImmediatePropagation?.();
};
